<!--
  REV-22096 — the hero constellation (Pure View). Every number below is the prototype's; see the
  class comment for why this is drawn per frame and not shipped as a static asset.
-->
<svg
    class="constellation"
    data-testid="closing-constellation"
    [attr.viewBox]="viewBox"
    [attr.width]="renderedWidth"
    [attr.height]="renderedHeight"
    role="img"
    aria-label="Die Arbeitsbereiche des Jahresabschlusses laufen in einem Ergebnis zusammen"
>
    <defs>
        <radialGradient id="abcp-constellation-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" [attr.stop-color]="mint" stop-opacity="0.22"></stop>
            <stop offset="55%" [attr.stop-color]="mint" stop-opacity="0.07"></stop>
            <stop offset="100%" [attr.stop-color]="mint" stop-opacity="0"></stop>
        </radialGradient>
        <linearGradient id="abcp-constellation-core" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#0f766e"></stop>
            <stop offset="100%" [attr.stop-color]="teal"></stop>
        </linearGradient>
        <filter id="abcp-constellation-shadow" x="-40%" y="-80%" width="180%" height="260%">
            <feDropShadow dx="0" dy="6" stdDeviation="9" [attr.flood-color]="teal" flood-opacity="0.32"></feDropShadow>
        </filter>
    </defs>

    <!-- The glow and the sphere's outline. -->
    <circle [attr.cx]="centerX" [attr.cy]="centerY" [attr.r]="radius + 60" fill="url(#abcp-constellation-glow)"></circle>
    <circle [attr.cx]="centerX" [attr.cy]="centerY" [attr.r]="radius + 6" fill="none" [attr.stroke]="teal" stroke-opacity="0.10"></circle>

    <!-- Three still latitude rings. -->
    <ellipse
        *ngFor="let ring of rings; trackBy: trackByKey"
        [attr.cx]="centerX"
        [attr.cy]="ring.cy"
        [attr.rx]="ring.rx"
        [attr.ry]="ring.ry"
        fill="none"
        [attr.stroke]="teal"
        stroke-opacity="0.07"
    ></ellipse>

    <!-- Six turning bands, each with one orbiting dot. -->
    <g *ngFor="let band of frame.bands; trackBy: trackByKey" [attr.transform]="'rotate(' + band.rotation + ' ' + centerX + ' ' + centerY + ')'">
        <ellipse [attr.cx]="centerX" [attr.cy]="centerY" [attr.rx]="bandRx" [attr.ry]="bandRy" fill="none" [attr.stroke]="teal" stroke-opacity="0.09"></ellipse>
        <circle [attr.cx]="band.dotX" [attr.cy]="band.dotY" r="2.6" [attr.fill]="mint" opacity="0.6"></circle>
    </g>

    <!-- Work areas tied to each other … -->
    <line
        *ngFor="let edge of frame.edges; trackBy: trackByKey"
        [attr.x1]="edge.x1"
        [attr.y1]="edge.y1"
        [attr.x2]="edge.x2"
        [attr.y2]="edge.y2"
        [attr.stroke]="teal"
        [attr.stroke-opacity]="edge.opacity"
    ></line>

    <!-- … and every one of them to the core, with dots travelling inwards. -->
    <g *ngFor="let spoke of frame.spokes; trackBy: trackByKey">
        <line [attr.x1]="spoke.x" [attr.y1]="spoke.y" [attr.x2]="centerX" [attr.y2]="centerY" [attr.stroke]="teal" [attr.stroke-opacity]="spoke.opacity"></line>
        <circle
            *ngFor="let dot of spoke.dots; trackBy: trackByKey"
            [attr.cx]="dot.x"
            [attr.cy]="dot.y"
            [attr.r]="dot.r"
            [attr.fill]="mint"
            [attr.opacity]="dot.opacity"
        ></circle>
    </g>

    <!-- The labels: a dot on the far side, a pill on the near side. -->
    <ng-container *ngFor="let pill of frame.pills; trackBy: trackByKey">
        <circle *ngIf="pill.kind === 'dot'" [attr.cx]="pill.x" [attr.cy]="pill.y" r="3" [attr.fill]="mint" opacity="0.35"></circle>
        <g
            *ngIf="pill.kind === 'pill'"
            data-testid="closing-constellation-label"
            [attr.transform]="'translate(' + pill.x + ' ' + pill.y + ') scale(' + pill.scale + ')'"
            [attr.opacity]="pill.opacity"
        >
            <rect
                [attr.x]="-pill.width / 2"
                [attr.y]="-pillHeight / 2"
                [attr.width]="pill.width"
                [attr.height]="pillHeight"
                [attr.rx]="pillHeight / 2"
                fill="#ffffff"
                [attr.stroke]="teal"
                [attr.stroke-opacity]="pill.strokeOpacity"
            ></rect>
            <circle [attr.cx]="pillDotX(pill)" cy="0" r="3.5" [attr.fill]="mint"></circle>
            <text [attr.x]="pillTextX(pill)" y="4.5" font-size="14" font-weight="600" fill="#1f2937" font-family="inherit">{{ pill.label }}</text>
        </g>
    </ng-container>

    <!-- The core. -->
    <g filter="url(#abcp-constellation-shadow)">
        <circle [attr.cx]="centerX" [attr.cy]="centerY" [attr.r]="frame.coreHaloRadius" [attr.fill]="mint" opacity="0.12"></circle>
        <rect
            [attr.x]="centerX - coreHalfWidth"
            [attr.y]="centerY - coreHalfHeight"
            [attr.width]="coreHalfWidth * 2"
            [attr.height]="coreHalfHeight * 2"
            [attr.rx]="coreHalfHeight"
            fill="url(#abcp-constellation-core)"
        ></rect>
        <text
            data-testid="closing-constellation-core"
            [attr.x]="centerX"
            [attr.y]="centerY + 6"
            text-anchor="middle"
            font-size="17"
            font-weight="700"
            fill="#ffffff"
            font-family="inherit"
        >
            {{ coreLabel }}
        </text>
    </g>
</svg>
